export default __webpack_public_path__ + "img/smgi_zusatz_mittelherkunft_intm.jpg";